module.exports = __webpack_public_path__ + "static/media/16UNODC15.a6740a71.jpg";